// from elemental ui

import React, { Component } from 'react';
import { width } from './constants';
import { omit } from 'lodash';

export default class Row extends Component {
  static defaultProps = {
    gutter: width.gutter
  };

  render() {
    let { gutter, justify } = this.props;
    let rowStyle = {
      display: 'flex',
      flexWrap: 'wrap',
      msFlexWrap: 'wrap',
      WebkitFlexWrap: 'wrap',
      marginLeft: (gutter / -2),
      marginRight: (gutter / -2),
      justifyContent: justify
    };

    let props = omit(this.props, 'gutter', 'style');

    return (
      <div
        className={`Row ${props.className}`}
        style={Object.assign(rowStyle, this.props.style)}
        children={this.props.children}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/row.js